import { render, staticRenderFns } from "./camera-permission-modal.vue?vue&type=template&id=9d7b8f0a&"
import script from "./camera-permission-modal.vue?vue&type=script&lang=js&"
export * from "./camera-permission-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports